import history from 'components/Layout/history';

export const goToVerificationPage = () => {
  history.push('/account/verification');
};

export const goToAccountNumbersPage = () => {
  history.push('/account/profile/account-numbers');
};
